import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ThemeColors, Typography } from '../../styles/ThemeStyles';
import { formatTextForDisplay } from '../../utils/formatText';

const FormattedTextContainer = styled.div`
  font-size: ${Typography.fontSize.md};
  line-height: 1.7;
  color: ${ThemeColors.text.primary};
  overflow-wrap: break-word;
  word-break: normal;

  p {
    margin: 0 0 0.75em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 0.75em;
    padding-left: 1.5em;
  }

  li {
    margin-bottom: 0.25em;
  }

  a {
    color: ${ThemeColors.primary.main};
    text-decoration: underline;
    font-weight: ${Typography.fontWeight.medium};
    word-break: normal;
    overflow-wrap: normal;

    &:hover {
      color: ${ThemeColors.primary.dark};
    }
  }

  strong,
  b {
    font-weight: ${Typography.fontWeight.bold};
  }
`;

export interface FormattedTextProps {
  content: string;
  className?: string;
}

export const FormattedText: React.FC<FormattedTextProps> = ({ content, className }) => {
  const html = useMemo(() => formatTextForDisplay(content), [content]);

  if (!html) return null;

  return (
    <FormattedTextContainer
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
